import React, { ComponentProps, RefObject } from 'react'
import { ScrollView } from 'react-native'

import { useDraggableScroll } from '~hooks'

export const DraggableScrollView = React.forwardRef<ScrollView, ComponentProps<typeof ScrollView>>(
  function DraggableScrollView(props, ref) {
    const { refs } = useDraggableScroll<ScrollView>({
      outerRef: ref as RefObject<ScrollView>,
      cursor: 'grab',
    })
    return <ScrollView ref={refs} horizontal {...props} />
  }
)
